import React from 'react';
import lodash, { isNumber } from 'lodash';
import FlowmeterHelper, { EnumFlowmeterMonitor } from '../../../../@types/model/flowmeter/flowmeter';
import { Autocomplete } from '@material-ui/lab';
import { createSelector } from 'reselect';
import { TextField } from '@material-ui/core';

export interface IFlowmeterMonitorDropDownOption {
    label : string;
    value : EnumFlowmeterMonitor | null;
}

interface IFlowmeterMonitorSelectorProps {
    value : EnumFlowmeterMonitor | null;
    disabled ?: boolean;
    className ?: string;
    required ?: boolean;
    onChange : (value : EnumFlowmeterMonitor | null) => void;
}

interface IFlowmeterMonitorSelectorState { }

class FlowmeterMonitorSelector extends React.Component<IFlowmeterMonitorSelectorProps, IFlowmeterMonitorSelectorState> {
    constructor(props : IFlowmeterMonitorSelectorProps) {
        super(props);

        this.state = {};
    }   

    private readonly onChange = (event : React.ChangeEvent<unknown>, value : {
        label : string;
        value : number | null;
    } | null | undefined) => {
        this.props.onChange(value?.value ?? null);
    };

    private readonly getValue = (state : IFlowmeterMonitorSelectorState, props : IFlowmeterMonitorSelectorProps) => props.value;
    private readonly getRequired = (state : IFlowmeterMonitorSelectorState, props : IFlowmeterMonitorSelectorProps) => props.required;

    private readonly getFlowmeterMonitorssForDropdown = createSelector([
        this.getRequired,
    ], (required,) => {
        const dropdownData : Array<IFlowmeterMonitorDropDownOption> = lodash
            .chain(EnumFlowmeterMonitor)
            .filter(x => isNumber(x))
            .map((element) => ({
                label: FlowmeterHelper.EnumFlowMeterMonitorToString[element],
                value: Number(element),
            }))
            .value();

        if (!required) {
            dropdownData.unshift({
                label: 'None',
                value: null,
            });
        }
        
        return dropdownData;
    });

    private readonly getSelectedValue = createSelector([
        this.getValue,
    ], (
        value,
    ) => {
        if (value != null) {
            const result = FlowmeterHelper.EnumFlowMeterMonitorToString[value];

            if (result) {
                return {
                    label: result,
                    value: value,
                } as IFlowmeterMonitorDropDownOption;
            }
        }

        return null;
    });

    public readonly render = () => {

        const { required, disabled } = this.props;

        const dropdownData = this.getFlowmeterMonitorssForDropdown(this.state, this.props);

        const value = this.getSelectedValue(this.state, this.props);

        return (
            <Autocomplete
                options={dropdownData}
                value={value}
                getOptionSelected={(option, val) => option.value === val.value}
                getOptionLabel={option => option.label}
                onChange={this.onChange}
                disableClearable={required}
                openOnFocus
                disabled={disabled}
                renderInput={params => (
                    <TextField
                        error={required && !value}
                        {...params}
                        required={required}
                        fullWidth
                        label={'Monitor Type'}
                    />
                )}  
            />
        );
    };

}

export default FlowmeterMonitorSelector;